<template>
  <SearchInput
    @search="handleSearch"
    @blur="handleBlur"
    @focus="emit('focus')"
    :selectedValue="selectedValue"
    :placeholder="placeholder"
    :autoFocus="autoFocus"
  />
</template>

<script setup>
import { ref } from 'vue'
import SearchInput from './SearchInput.vue'

const props = defineProps({
  searchFunction: {
    type: Function,
    required: true
  },
  selectedValue: {
    type: String
  },
  placeholder: {
    type: String,
    default: 'Search'
  },
  autoFocus: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['results', 'error', 'stateChange', 'blur', 'focus'])

const state = ref('idle')
let currentSearchAbortController = null

async function handleSearch(query) {
  if (currentSearchAbortController) {
    currentSearchAbortController.abort()
  }

  currentSearchAbortController = new AbortController()
  setState('searching')

  try {
    const results = await props.searchFunction(query, currentSearchAbortController.signal)
    emit('results', results)
    setState('idle')
  } catch (error) {
    console.error(error)
    if (error.name !== 'AbortError') {
      emit('error', error)
      setState('idle')
    }
    // @Todo: this can silently fail rn.
  }
}

function handleBlur() {
  if (state.value === 'idle') {
    emit('blur')
  }
}

function setState(newState) {
  state.value = newState
  emit('stateChange', newState)
}
</script>
